import Tabs from '../../../../components/patterns/Tabs.jsx';
import GallerySection from './GallerySection.jsx';

const TAB_ITEMS = [
  { value: 'overview', label: 'Overview', panel: <p className="gallery-panel-text">Runs every Monday at 9:00 and follows up on invoices more than 30 days overdue.</p> },
  { value: 'runs', label: 'Runs', panel: <p className="gallery-panel-text">24 runs in the last 6 months. The last one is waiting for your approval.</p> },
  { value: 'permissions', label: 'Permissions', panel: <p className="gallery-panel-text">Reads invoices in QuickBooks. Creates drafts and sends email from billing@northwind.co after you approve.</p> },
  { value: 'history', label: 'Change history', panel: <p className="gallery-panel-text">Created by Ana Lucia Ortega on March 3.</p> }
];

const NavigationSection = () => {
  return (
    <GallerySection id="navigation" title="Navigation" description="Tabs switch views of one subject. The sidebar on the left shows the nav item: selected, hover and with a count.">
      <Tabs items={TAB_ITEMS} label="Automation details" />
    </GallerySection>
  );
};

export default NavigationSection;
